
import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Edit2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface ProfileHeaderProps {
  displayName: string | null;
  username: string | null;
  avatarUrl: string | null;
  disciplines: string | null;
  organisatie: string | null;
  yearsExperience: number | null;
  bio: string | null;
  onEditClick: () => void;
}

export function ProfileHeader({
  displayName,
  username,
  avatarUrl,
  disciplines,
  organisatie,
  yearsExperience,
  bio,
  onEditClick,
}: ProfileHeaderProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between">
        <div className="flex gap-4">
          <Avatar className="h-20 w-20">
            <AvatarImage src={avatarUrl || undefined} />
            <AvatarFallback>{(displayName || username || "?")[0].toUpperCase()}</AvatarFallback>
          </Avatar>
          <div>
            <h1 className="text-2xl font-bold">{displayName || username || "Naamloos profiel"}</h1>
          </div>
        </div>
        <div>
          <Button onClick={onEditClick}>
            <Edit2 className="h-4 w-4 mr-2" />
            Bewerk profiel
          </Button>
        </div>
      </div>

      <Card>
        <CardContent className="grid gap-4 pt-6">
          {disciplines && (
            <div>
              <h3 className="font-semibold mb-1">Disciplines</h3>
              <p className="text-muted-foreground">{disciplines}</p>
            </div>
          )}
          
          {organisatie && (
            <div>
              <h3 className="font-semibold mb-1">Organisatie</h3>
              <p className="text-muted-foreground">{organisatie}</p>
            </div>
          )}
          
          {yearsExperience !== null && (
            <div>
              <h3 className="font-semibold mb-1">Jaren ervaring</h3>
              <p className="text-muted-foreground">{yearsExperience}</p>
            </div>
          )}
          
          {bio && (
            <div>
              <h3 className="font-semibold mb-1">Bio</h3>
              <p className="text-muted-foreground whitespace-pre-wrap">{bio}</p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
